module.exports = __webpack_public_path__ + "static/07_ERAC_key_RGB-950e252d7d748898d5a310997b0c3e4d.png";